import { render, staticRenderFns } from "./Shortlist.vue?vue&type=template&id=1ed50884&scoped=true&"
import script from "./Shortlist.vue?vue&type=script&lang=js&"
export * from "./Shortlist.vue?vue&type=script&lang=js&"
import style0 from "./Shortlist.vue?vue&type=style&index=0&id=1ed50884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed50884",
  null
  
)

export default component.exports